
import { Component, Vue, Prop } from 'vue-property-decorator';
import ServiceCodesServiceAutocompleteField from '@/components/fields/ServiceCodesServiceAutocompleteField.vue';
import ServiceCodesQuantityNumberField from '@/components/fields/ServiceCodesQuantityNumberField.vue';
import { StopServices } from '@/models/jobDetailed';
import LegsBlockBtn from '@/components/btns/LegsBlockBtn.vue';
import LegsSmallRoundBtn from '@/components/btns/LegsSmallRoundBtn.vue';
import _uniqueId from 'lodash/uniqueId';

@Component({
  components: {
    ServiceCodesServiceAutocompleteField,
    ServiceCodesQuantityNumberField,
    LegsBlockBtn,
    LegsSmallRoundBtn,
  },
})
export default class ServiceCodesFieldset extends Vue {
  @Prop(Array) public value: StopServices[];
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  get services() {
    // console.debug('get services');
    return this.value;
  }

  set services(value) {
    // console.debug('set services', value);
    this.$emit('input', value);
  }

  public handleDelClick(_clientId: string) {
    // console.debug('handleDelClick', _clientId);
    this.services = this.services.filter(service => service._clientId !== _clientId);
  }

  public handleAddClick() {
    this.services = [
      ...this.services,
      {
        name: '',
        quantity: 1,
        _clientId: _uniqueId(),
      },
    ];
  }
}
